/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
  require('./bootstrap');
  import Vue from 'vue';
  window.Vue = Vue;

// Imports
import Vuex from 'vuex';
import draggable from 'vuedraggable';
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import spinnerPulseLoader from 'vue-spinner/src/PulseLoader.vue'
import spinnerClipLoader from 'vue-spinner/src/ClipLoader.vue'
// import ECharts from 'vue-echarts';
import VueRx from 'vue-rx';

//panel docentes
import Evaluaciones from './components/panel-docentes/Evaluaciones.vue';
import CargaMaterial from './components/panel-docentes/carga-material/carga-material.vue';
import Observaciones from './components/panel-docentes/observaciones/observaciones.vue';

// Librerías de terceros
Vue.use(Vuex);
Vue.use(VueRx);
Vue.use(require('vue-moment'));
Vue.component('InfiniteLoading', require('vue-infinite-loading'));
Vue.component('v-select', vSelect);

// cell render components
Vue.component('v-cell-edit', require('./components/cellRender/editField.vue').default);
Vue.component('v-cell-save', require('./components/cellRender/saveField.vue').default);

// Componentes
Vue.component('v-table', require('./components/TableComponent.vue').default);
Vue.component('v-form', require('./components/FormComponent.vue').default);
Vue.component('v-modal-form', require('./components/ModalFormComponent.vue').default);
Vue.component('v-option', require('./components/OptionComponent.vue').default);
Vue.component('k-modal-form', require('./components/KiraModalFormComponent.vue').default);
Vue.component('k-form', require('./components/KiraFormComponent.vue').default);
Vue.component('k-select', require('./components/KiraSelectComponent.vue').default);
Vue.component('k-select-multiple', require('./components/KiraSelectMultipleComponent.vue').default);
Vue.component('k-select-group', require('./components/KiraSelectGroupComponent.vue').default);
Vue.component('v-avatar-dialog', require('./components/AvatarDialogComponent.vue').default);
Vue.component('k-input', require('./components/KiraInputComponent.vue').default);
Vue.component('k-switcher', require('./components/KiraSwitcherComponent.vue').default);
Vue.component('v-upload-file', require('./components/pages/landing/UploadFile.vue').default);
Vue.component('k-vue-select', require('./components/KiraVueSelectInputComponent.vue').default)
Vue.component('v-help-system', require('./components/HelpSystemComponent.vue').default)
Vue.component('v-help-button', require('./components/HelpButtonComponent.vue').default)
Vue.component('k-button-action-direct', require('./components/ButtonActionDirect.vue').default);


Vue.component('v-stepper', require('./components/StepperComponent.vue').default)
Vue.component('v-step', require('./components/StepComponent.vue').default)

// Landing Page
Vue.component('v-landing-page', require('./components/pages/landing/LandingPage.vue').default);
Vue.component('v-timeline-item', require('./components/pages/landing/TimelineItemComponent.vue').default);
Vue.component('v-comment', require('./components/pages/landing/CommentComponent.vue').default);
Vue.component('v-comment', require('./components/pages/landing/CommentComponent.vue').default);
Vue.component('v-search-brother', require('./components/pages/landing/SearchBrother.vue').default);
// Decoumentos Page
Vue.component('v-documentos-page', require('./components/pages/documentos/DocumentosPage.vue').default);
// Asignaturas Page
Vue.component('v-asignaturas-page', require('./components/pages/asignaturas/AsignaturasPage.vue').default);
Vue.component('v-asignaturas-page2', require('./components/pages/asignaturas/AsignaturasPage2.vue').default);
// Soporte Page
Vue.component('v-soporte-page', require('./components/pages/soporte/SoportePage.vue').default);
// Contacto Page
Vue.component('v-contacto-page', require('./components/pages/contacto/ContactoPage.vue').default);
// CRNS Page
Vue.component('v-crns-page', require('./components/pages/crns/CrnsPage.vue').default);
// Ticket Admin Page
Vue.component('v-ticket-admin-page', require('./components/pages/soporte/TicketAdminPage.vue').default);
Vue.component('v-ticket-page', require('./components/pages/soporte/TicketPage.vue').default);
// Ticket Panel Page
Vue.component('p-total-tickets-correos-atendidos', require('./components/pages/soporte/panel/TotalTicketsCorreosAtendidos.vue').default);
Vue.component('p-historial-tickets-correos', require('./components/pages/soporte/panel/HistorialTicketsCorreos.vue').default);
// Header
Vue.component('v-header-searchbar', require('./components/pages/header/HeaderSearchbar.vue').default);
// Prospectos
Vue.component('v-buscar-familia', require('./components/pages/prospectos/BuscarFamilia.vue').default);
Vue.component('v-buscar-hermanos', require('./components/pages/prospectos/BuscarHermanos.vue').default);
Vue.component('v-prospectos-page', require('./components/pages/prospectos/ProspectosPage.vue').default);
// Grupos Administrativos
Vue.component('v-grupos-administrativos-page', require('./components/pages/grupos-administrativos/GruposAdministrativosPage.vue').default);

// Docentes
Vue.component('vinculardocente', require('./components/pages/docentes/VincularDocente.vue').default);

// Cambio de Institución
Vue.component('v-cambio-institucion-page', require('./components/pages/cambio-institucion/CambioInstitucion.vue').default);
// Estado de cuenta
Vue.component('v-estado-de-cuenta-page', require('./components/pages/estado-de-cuenta/EstadoDeCuentaPage.vue').default);
// Dashboard
Vue.component('v-dashboard-page', require('./components/pages/dashboard/DashboardPage.vue').default);
// Vue.component('v-dashboard-prospectos-status-chart', require('./components/pages/dashboard/ProspectosStatusChart.vue').default);
// Vue.component('v-dashboard-alumnos-ciclo-origen-chart', require('./components/pages/dashboard/constantes/AlumnosCicloOrigen.vue').default);
// Vue.component('v-dashboard-alumnos-inscripcion-pago-chart', require('./components/pages/dashboard/constantes/AlumnosInscripcionPago').default);

// Charts
Vue.component('v-line-chart', require('./components/charts/LineChart.vue').default);
Vue.component('v-bar-chart', require('./components/charts/BarChart.vue').default);
Vue.component('v-horizontal-bar-chart', require('./components/charts/HorizontalBarChart.vue').default);
Vue.component('v-doughnut-chart', require('./components/charts/DoughnutChart.vue').default);
// Vue.component('v-echart', require('./components/charts/EChart.vue').default);
//Vue.component('v-chart', ECharts);

// Directivas
Vue.component('d-instituciones', require('./components/directivas/Instituciones.vue').default);
Vue.component('d-ciclos-escolares', require('./components/directivas/CiclosEscolares.vue').default);
Vue.component('d-niveles-academicos', require('./components/directivas/NivelesAcademicos.vue').default);
Vue.component('d-programas', require('./components/directivas/Programas.vue').default);
Vue.component('d-atributos', require('./components/directivas/Atributos.vue').default);
Vue.component('d-ofertas-academicas', require('./components/directivas/OfertasAcademicas.vue').default);

Vue.component('v-counter-view', require('./components/charts/views/CounterView.vue').default);
Vue.component('v-counter-percent-view', require('./components/charts/views/CounterPercentView.vue').default);
Vue.component('v-bar-chart-view', require('./components/charts/views/BarChartView.vue').default);
Vue.component('v-line-chart-view', require('./components/charts/views/LineChartView.vue').default);
Vue.component('v-doughnut-chart-view', require('./components/charts/views/DoughnutChartView.vue').default);
Vue.component('v-text-view', require('./components/charts/views/TextView.vue').default);

// New Version Neutron Components (Beta Version) (NO USAR!)
Vue.component('n-modal', require('./components/neutron/NeutronModal.vue').default);
Vue.component('n-form', require('./components/neutron/NeutronForm.vue').default);
Vue.component('n-row', require('./components/neutron/NeutronRow.vue').default);
Vue.component('n-jump', require('./components/neutron/NeutronJump.vue').default);
Vue.component('n-select', require('./components/neutron/NeutronSelect.vue').default);
Vue.component('n-input', require('./components/neutron/NeutronInput.vue').default);
Vue.component('n-button-modal', require('./components/neutron/NeutronButtonModal.vue').default);

//Parcializacion
Vue.component('parcializacion-reglas-cobro-form', require('./components/administracion/parcializacion_reglas_de_cobro/FormPartializationComponent.vue').default);
Vue.component('reglas-cobro-table', require('./components/administracion/reglas-de-cobro/ReglasCobroTable.vue').default);
Vue.component('copiar-reglas-modal', require('./components/administracion/reglas-de-cobro/CopiarReglasModal.vue').default);

//Promociones
Vue.component('promociones-filtros', require('./components/administracion/promociones/promociones.vue').default);
Vue.component('promociones-table', require('./components/administracion/promociones/PromocionesTable.vue').default);

//Academico -Componentes Academicos
Vue.component('tabla-collapse-componentes', require('./components/academico/componentes_academicos/TableCollapseComponent.vue').default);
Vue.component('cell-componentes-academicos-acciones', require('./components/academico/cellRender/cellComponentesAcademicosAcciones.vue').default);
Vue.component('cell-detalle-componentes-academicos-acciones', require('./components/academico/cellRender/cellDetalleComponentesAcademicosAcciones.vue').default);
Vue.component('cell-detalle-componentes-academicos-acciones-detalle-promediar', require('./components/academico/cellRender/cellDetalleComponentesAcademicosDetallesPromediar.vue').default);

//Indicadores-alumno
Vue.component('alumnos-reporte', require('./components/indicadores/alumnos_por_ciclo/alumnosReporteComponent.vue').default);
Vue.component('pulse-loader', require('vue-spinner/src/PulseLoader.vue'));

// Vue.component('v-conciliacion-bancaria-banamex', require('./components/administracion/conciliacion/banamex/ConciliacionBancariaBanamex.vue').default);
// Vue.component('v-input-busqueda-personas', require('./components/administracion/conciliacion/banamex/partials/BusquedaPersonas.vue').default);
Vue.component('v-cargar-certificado', require('./components/administracion/facturacion/CargarArchivoCertificado.vue').default);
Vue.component('v-conciliacion-de-pagos', require('./components/administracion/conciliacion/ConciliacionDePagos.vue').default);
Vue.component('v-certificados-institucion', require('./components/administracion/facturacion/Certificados.vue').default);
Vue.component('v-planta-fisica-institucion', require('./components/PlantaFisicaComponent.vue').default);
Vue.component('v-wysiwyg', require('./components/Wysiwyg.vue').default);



// Bloques- CRNS - page
Vue.component('v-bloques-page', require('./components/pages/bloques/bloquesPage.vue').default);
// Bloques-Asignar- page
Vue.component('v-asignar-bloques', require('./components/pages/asignar-bloques/asignarBloques.vue').default);

// Nuevos componentes reestructura

Vue.component('v-registro-prospecto', require('./components/nuevos/registro-prospecto/registro-prospecto.vue').default);
Vue.component('v-registro-prospecto-aviso-privacidad', require('./components/nuevos/registro-prospecto/aviso-privacidad.vue').default);
Vue.component('v-landing-cobranza', require('./components/nuevos/landing/cobranza.vue').default);
Vue.component('v-proceso-admision', require('./components/nuevos/landing/proceso_admision/proceso_admision.vue').default);
Vue.component('v-landing-cobranza-admin', require('./components/nuevos/landing-profesores/landing.vue').default);
Vue.component('v-historial', require('./components/nuevos/landing/historial.vue').default);
Vue.component('v-estadistica', require('./components/nuevos/landing/estadisticas-pago.vue').default);
Vue.component('v-cargo', require('./components/nuevos/landing/estadisticas-cargo.vue').default);
Vue.component('v-reportes-ingresos', require('./components/nuevos/reportes/ingresos.vue').default);
Vue.component('v-reportes-calificaciones', require('./components/nuevos/reportes/calificaciones/calificaciones.vue').default);
Vue.component('v-reportes-cargos', require('./components/nuevos/reportes/cargos/cargos.vue').default);
Vue.component('v-grupos-academicos', require('./components/nuevos/reportes/grupos-academicos/grupos-academicos.vue').default);
Vue.component('v-reportes-dinamicos', require('./components/nuevos/reportes/dinamico/dinamico.vue').default);
Vue.component('v-reportes-conciliacion', require('./components/nuevos/reportes/conciliacion/conciliacion.vue').default);
Vue.component('v-reportes-facturacion', require('./components/nuevos/reportes/facturacion/facturacion.vue').default);
Vue.component('v-archivos-domicializacion', require('./components/nuevos/landing/domicializacion/archivos-domicializacion.vue').default);
Vue.component('v-mailing', require('./components/nuevos/mailing/mailing.vue').default);
Vue.component('v-redactar', require('./components/nuevos/mailing/redactar.vue').default);
Vue.component('v-padre-finanzas', require('./components/nuevos/padres/estadisticas.vue').default);
// REPORTES
Vue.component('v-cartera-vencida', require('./components/nuevos/reportes/cartera-vencida/cartera-vencida.vue').default);
Vue.component('v-reporte-prospectos', require('./components/nuevos/reportes/prospectos/prospectos.vue').default);
Vue.component('v-accesos-alumnos', require('./components/nuevos/reportes/accesos-alumno/accesos-alumno.vue').default);
Vue.component('v-accesos-personas', require('./components/nuevos/reportes/accesos-personas/accesos-personas.vue').default);
Vue.component('v-alumnos-inscritos', require('./components/nuevos/reportes/alumnos-inscritos/alumnos-inscritos.vue').default);
Vue.component('v-becas', require('./components/nuevos/reportes/becas/becas.vue').default);
Vue.component('v-seguimiento-inscripcion', require('./components/nuevos/reportes/seguimiento-inscripcion/seguimiento-inscripcion.vue').default);
Vue.component('v-reportes-descarga-boleta', require('./components/nuevos/reportes/descarga-boleta/descarga-boleta.vue').default);
Vue.component('v-reportes-actualizacion-documentos', require('./components/nuevos/reportes/actualizacion-documentos/actualizacion-documentos.vue').default);
Vue.component('v-monitor-calificaciones', require('./components/nuevos/reportes/monitor-calificaciones/monitor-calificaciones.vue').default);
Vue.component('v-reporte-datos-fiscales', require('./components/nuevos/reportes/datos-fiscales/datos-fiscales.vue').default);
Vue.component('v-saldos-iniciales', require('./components/nuevos/reportes/saldos-iniciales/saldos-iniciales.vue').default);
Vue.component('v-becas-aplicadas', require('./components/nuevos/reportes/becas-aplicadas/becas-aplicadas.vue').default);
Vue.component('v-horarios', require('./components/nuevos/reportes/horarios/horarios.vue').default);
Vue.component('v-usabilidad-sigem', require('./components/nuevos/indicadores/usabilidad-sigem/usabilidad-sigem.vue').default);
Vue.component('v-finanzas-sim', require('./components/nuevos/reportes/finanzas-sim/finanzas-sim.vue').default);
//CONFIGURACIÓN
Vue.component('v-indicadores-becas-descuentos', require('./components/nuevos/indicadores/becas-descuentos/becas-descuentos.vue').default);
// ADMINISTRACIÓN
Vue.component('v-subcategoria-servicio', require('./components/nuevos/administracion/subcategorias-servicios/subcategorias-servicios.vue').default);
// SERVICIOS ESCOLARES
Vue.component('v-inscripcion-masiva', require('./components/nuevos/servicios_escolares/inscripcion_masiva.vue').default);
Vue.component('v-fotografias-masivas', require('./components/nuevos/servicios_escolares/fotografias-masivas/fotografias-masivas.vue').default);
Vue.component('v-gestion-servicios-escolares', require('./components/nuevos/servicios_escolares/gestion_servicios_escolares/gestion_servicios_escolares.vue').default);
Vue.component('v-matricula', require('./components/nuevos/servicios_escolares/matricula/matricula.vue').default);
Vue.component('v-desvincular-alumno', require('./components/nuevos/servicios_escolares/desvincular_alumno/desvincular_alumno.vue').default);
Vue.component('v-asignar-becas', require('./components/nuevos/servicios_escolares/asignar-becas/asignar-becas.vue').default);
// ACADEMICO
Vue.component('v-programas', require('./components/nuevos/academico/programa/programa.vue').default);
Vue.component('v-escala-calificaciones', require('./components/nuevos/academico/escala_calificaciones/escala-calificaciones.vue').default);
Vue.component('v-configuracion-calificaciones', require('./components/nuevos/academico/configuracion-calificaciones/configuracion-calificaciones.vue').default);
Vue.component('v-configuracion-boleta', require('./components/nuevos/academico/configuracion-boleta/configuracion-boleta.vue').default);
Vue.component('v-componentes-academicos', require('./components/nuevos/academico/componentes-academicos/componentes-academicos.vue').default);
Vue.component('v-calculo-promedios', require('./components/nuevos/academico/calculo-promedios/calculo-promedios.vue').default);
Vue.component('v-fecha-vigencia', require('./components/nuevos/academico/fecha-vigencia/fecha-vigencia.vue').default);
Vue.component('v-codigo-detalle', require('./components/nuevos/academico/codigo-detalle/codigo-detalle.vue').default);
Vue.component('v-gestion-becas', require('./components/nuevos/academico/gestion-becas/gestion-becas.vue').default);
Vue.component('v-docentes', require('./components/nuevos/academico/docentes/docentes.vue').default);
Vue.component('v-plan-estudio', require('./components/nuevos/academico/plan-estudio/plan-estudio.vue').default);
Vue.component('v-aula-vs-alumno', require('./components/nuevos/academico/aula-vs-alumno/aula-vs-alumno.vue').default);
Vue.component('v-campo-formativos-docente', require('./components/nuevos/academico/campo_formativo_docente/campo_formativo_docente.vue').default);
// LANDING
Vue.component('v-mapa-inscripcion', require('./components/nuevos/landing/mapa-inscripcion/mapa-inscripcion.vue').default);
Vue.component('v-intencion-pagos', require('./components/nuevos/alumno/components/intencion-pagos.vue').default);
Vue.component('v-intencion-pagos-santander', require('./components/nuevos/alumno/components/intencion-pagos-santander.vue').default);
// Vue.component('v-info-alumno', require('./components/nuevos/landing/info/info-alumno.vue').default);
Vue.component('v-rol-usuario', require('./components/nuevos/alumno-profesor/alumno-profesor.vue').default);
Vue.component('v-boleta', require('./components/nuevos/landing/boleta/boleta.vue').default);
Vue.component('v-expediente-digital', require('./components/nuevos/landing/expediente-digital/expediente-digital.vue').default);
Vue.component('v-domicializacion', require('./components/nuevos/landing/domicializacion/agregar-cuenta.vue').default);
Vue.component('v-proceso-inscripcion', require('./components/nuevos/landing/proceso-inscripcion/proceso-inscripcion.vue').default);
Vue.component('v-datos-fiscales', require('./components/nuevos/landing/datos-fiscales/datos-fiscales.vue').default);
// ADMINISTRACIÓN
Vue.component('v-reglas-cobro', require('./components/nuevos/administracion/reglas-cobro/reglas-cobro.vue').default);
// ADMISIONES
Vue.component('v-prospectos', require('./components/nuevos/admisiones/prospectos/prospectos.vue').default);
Vue.component('v-oferta-academica', require('./components/nuevos/admisiones/ofertas-academicas/oferta-academica.vue').default);
//CONFIGURACIÓN
Vue.component('v-configuracion-documentos', require('./components/nuevos/configuracion/documentos/documentos.vue').default);

//ACCESIBILIDAD SIGEM
Vue.component('v-gestion-roles', require('./components/nuevos/accesibilidad-sigem/gestion-roles/gestion-roles.vue').default);
Vue.component('v-familiares-masivo', require('./components/nuevos/accesibilidad-sigem/familiares-masivo/familiares-masivo.vue').default);
Vue.component('v-gestion-usuarios', require('./components/nuevos/accesibilidad-sigem/gestion-usuarios/gestion-usuarios.vue').default);
Vue.component('v-acceso-familiares-masivo', require('./components/nuevos/accesibilidad-sigem/acceso-masivo-familiares/acceso-masivo-familiares.vue').default);
Vue.component('v-acceso-masivo-alumnos', require('./components/nuevos/accesibilidad-sigem/acceso-masivo-alumnos/acceso-masivo-alumnos.vue').default);

// Panel docentes
Vue.component('v-evaluaciones', Evaluaciones);
Vue.component('v-carga-material', CargaMaterial);
Vue.component('v-observaciones', Observaciones);

Vue.component('v-landing-alumno', require('./components/nuevos/alumno/alumno.vue').default);
// FEEDBACK
Vue.component('v-feedback', require('./components/nuevos/feedback/feedback.vue').default);


Vue.component('v-finanzas-alumno', require('./components/nuevos/familiar/familiar.vue').default);
Vue.component('v-descarga-material', require('./components/nuevos/familiar/descarga-material/descargar-material.vue').default);
Vue.component('v-familiares', require('./components/nuevos/familiar/gestion-familiares/gestion-familiares.vue').default);
Vue.component('v-descargar-boleta', require('./components/nuevos/familiar/boleta/descargar-boleta.vue').default);
Vue.component('v-inscripcion-academica', require('./components/nuevos/familiar/inscripcion-academica/inscripciones-academicas.vue').default);



import './filters/filters'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css' //Vuesax styles
Vue.use(Vuesax, {
// options here
})

import VueDragscroll from 'vue-dragscroll'
Vue.use(VueDragscroll)

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
Vue.use(VueMaterial)

// Vuex
const store = new Vuex.Store({
	state: {
		debug: true,
		rowSelected: -1,
	},
	mutations: {
		setRowSelected(state, val) {
			state.rowSelected = val;
		}
	}
});


Vue.prototype.window = window;
Vue.config.productionTip = false;
const app = new Vue({
	el: '#app',
	store: store,
	components: {
		draggable,
		spinnerPulseLoader,
		spinnerClipLoader,
	},
});
